var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    zoomAndPan: "magnify",
    viewBox: "0 0 112.5 112.499997",
    height: 150,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "72dffffbc1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 112.003906 0 L 112.003906 112.003906 L 0 112.003906 Z M 0 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#72dffffbc1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 112.5 95.390625 C 112.5 104.832031 104.847656 112.488281 95.40625 112.488281 L 17.097656 112.488281 C 7.65625 112.488281 0.00390625 104.832031 0.00390625 95.390625 L 0.00390625 17.085938 C 0.00390625 7.644531 7.65625 -0.0078125 17.097656 -0.0078125 L 95.40625 -0.0078125 C 104.847656 -0.0078125 112.5 7.644531 112.5 17.085938 Z M 112.5 95.390625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1a4789",
    d: "M 74.542969 64.980469 L 76.363281 50.875 L 62.394531 50.875 L 62.394531 41.867188 C 62.394531 37.785156 63.535156 35 69.390625 35 L 76.851562 34.996094 L 76.851562 22.382812 C 75.566406 22.210938 71.132812 21.824219 65.972656 21.824219 C 55.203125 21.824219 47.832031 28.402344 47.832031 40.472656 L 47.832031 50.875 L 35.652344 50.875 L 35.652344 64.980469 L 47.832031 64.980469 L 47.832031 101.171875 L 62.394531 101.171875 L 62.394531 64.980469 Z M 74.542969 64.980469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.508f6d7a4068ff5b5dc5027cd752f29b.svg";
export { ForwardRef as ReactComponent };